export const multiply = (a: number, b: number, precision = 5) => {
    return Number((a * b).toFixed(precision));
};
export const divide = (a: number, b: number, precision = 5) => {
    if (b === 0) throw new Error("Division by zero.");
    return Number((a / b).toFixed(precision));
};
export const sum = (a: number, b: number, precision = 5) => {
    return Number((a + b).toFixed(precision));
};
export const subtract = (a: number, b: number, precision = 5) => {
    return Number((a - b).toFixed(precision));
};
export const round = (a: number, target: number, precision = 5) => {
    return multiply(Math.round(divide(a, target, precision)), target, precision);
};

export const roundTo2Decimals = (value: number): number => {
    // Round to 2 decimals using "round half up" algorithm
    // This is the standard approach for currency rounding
    // Handles floating point precision issues by using a small epsilon

    // Handle zero and NaN
    if (value === 0 || !isFinite(value)) {
        return value;
    }

    // Handle negative numbers
    const sign = value < 0 ? -1 : 1;
    const absValue = Math.abs(value);

    // Standard "round half up": multiply by 100, add 0.5, floor, divide by 100
    // The epsilon (1e-10) handles floating point precision issues where
    // values like 9.995 * 100 = 999.4999999999999 instead of 999.5
    // This epsilon is 8 orders of magnitude smaller than our precision (0.01),
    // so it only affects values exactly at the .5 boundary, which is what we want
    const scaled = absValue * 100 + 0.5 + 1e-10;
    const rounded = Math.floor(scaled);

    return (rounded / 100) * sign;
};

export const roundTo3Decimals = (value: number): number => {
    // Round to 3 decimals using "round half up" algorithm
    // Used for totalTaxes to preserve precision during aggregation

    // Handle zero and NaN
    if (value === 0 || !isFinite(value)) {
        return value;
    }

    // Handle negative numbers
    const sign = value < 0 ? -1 : 1;
    const absValue = Math.abs(value);

    // Standard "round half up": multiply by 1000, add 0.5, floor, divide by 1000
    // The epsilon (1e-10) handles floating point precision issues
    const scaled = absValue * 1000 + 0.5 + 1e-10;
    const rounded = Math.floor(scaled);

    return (rounded / 1000) * sign;
};

export function getDatesForRange(dateRange: "thisWeek" | "thisMonth" | "thisYear" | "last30Days") {
    const now = new Date();
    let start = new Date(0);
    switch (dateRange) {
        case "thisWeek":
            start = new Date(now.getFullYear(), now.getMonth(), now.getDate() - now.getDay());
            break;
        case "thisMonth":
            start = new Date(now.getFullYear(), now.getMonth(), 1);
            break;
        case "thisYear":
            start = new Date(now.getFullYear(), 0, 1);
            break;
        case "last30Days":
            start = new Date(now.getTime() - 30 * 24 * 60 * 60 * 1000);
            break;
    }
    return { start };
}
